/**
 * API / Skills 页面文案（ClawHub / OpenClaw 官方 Skills 说明）
 */
const en = {
    skillsH1: 'WeryAI Official Skills',
    skillsPageTitle: 'WeryAI Official Skills',
    skillsIntro:
        'Official WeryAI Skills let you plug WeryAI into AI assistant platforms (such as OpenClaw) and use our generation APIs quickly.',

    section1Title: 'Skills overview',
    clawHubMore: 'View Skills details on WeryAI platform',
    colSlug: 'Skill slug',
    colFeature: 'Capability',
    colUrl: 'ClawHub link',

    featVideoGen: 'Video generation',
    featImageGen: 'Image generation',
    featMusicGen: 'Music generation',
    featPodcastGen: 'Podcast generation',
    featVideoEdit: 'Video editing',
    featImageEdit: 'Image editing',
    featAccount: 'API balance & credits',

    section2Title: 'How to install',
    method1Title: 'Method 1',
    method1Hint: 'Tell your assistant 🦞:',
    method1LinePrefix: 'Install Skill:',

    method2Title: 'Method 2',
    method2Hint: 'Tell your assistant 🦞:',
    method2Line1: 'Install this Skill:',

    method3Title: 'Method 3',
    method3Hint:
        'Go to ClawHub, search for weryai and download the zip archive.',
    method3Box:
        'Unzip the archive and place the contents into your local OpenClaw skills directory.',

    section3Title: 'How to use',
    step1Title: 'Sign in at weryai.com and create an API Key',
    step1Warning: 'Please keep your API Key secure. Do not share.',
    step2Title:
        'After completing API configuration in OpenClaw, send your message content.',
    step2CodePrefix: 'Message content: refer to the illustration below.',

    ex1User: 'Generate an image of a woman with coffee.',
    ex1Bot1: 'I will generate one for you.',
    ex1Bot2: 'Done — generated successfully ✅',
    ex1LinkLabel: 'Image URL:',
    ex1Bot3:
        'I can also offer two more styles (realistic / cinematic) to choose from.',
    ex1Alt: 'Sample image',

    ex2User: 'Use Werydance2.0 to generate a dance video.',
    ex2Bot1: 'Okay, generating directly with Werydance2.0 as requested.',
    ex2Bot2: 'Done ✅ (model: Werydance2.0)',
    ex2LinkLabel: 'Video URL:',
    ex2Bot3:
        'I can also try a more “tech stage lighting” or street-dance style version.',
    ex2Alt: 'Sample video frame',
    ex2Badge: 'GIF',

    ex3User: 'Generate a Chinese podcast introducing WeryAI.',
    ex3Bot1:
        'I will generate a two-host Chinese podcast introducing weryai.com.',
    ex3Bot2: 'Here is the Chinese intro podcast:',
    ex3AudioLabel: 'Podcast audio (MP3)',
    ex3ParamsTitle: 'Parameters:',
    ex3ParamLang: 'Language:',
    ex3ParamMode: 'Mode:',
    ex3ParamHosts: 'Hosts:',
    ex3ParamTaskId: 'Task ID:',
    ex3HostsValue: 'Xiaoman + Suzhe',
    ex3Bot4: 'I can also make a shorter 60–90s promo cut.',
    ex3Filename: 'weryai_880c86f898ef76daea513e260046a21e.mp3',
    ex3Time: '0:07',

    linkPlaceholder: 'https://static.weryai.com/...',
    demoSlug: 'weryai-video-generator',
    demoInstallUrl:
        'https://clawhub.ai/WeryAI-Developer/weryai-video-generator',
}

const zh = {
    skillsH1: 'WeryAI 官方 Skills',
    skillsPageTitle: 'WeryAI 官方 Skills',
    skillsIntro:
        'WeryAI 提供的官方 Skills 插件，帮助您在各类 AI 助手平台（如 OpenClaw / 龙虾）中快速集成和使用 WeryAI 的强大能力。',

    section1Title: 'Skills 功能介绍',
    clawHubMore: '查看WeryAI平台的Skills详情',
    colSlug: 'Skill Slug',
    colFeature: '功能',
    colUrl: 'ClawHub 地址',

    featVideoGen: '视频生成',
    featImageGen: '图片生成',
    featMusicGen: '音乐生成',
    featPodcastGen: '播客生成',
    featVideoEdit: '视频编辑',
    featImageEdit: '图片编辑',
    featAccount: 'API 账号积分余额查询',

    section2Title: '如何安装',
    method1Title: '方法一',
    method1Hint: '告诉你的龙虾 🦞：',
    method1LinePrefix: '安装 Skill：',

    method2Title: '方法二',
    method2Hint: '告诉你的龙虾 🦞：',
    method2Line1: '安装这个Skill：',

    method3Title: '方法三',
    method3Hint:
        '前往 ClawHub 搜索 weryai 并下载压缩包。',
    method3Box:
        '将压缩包解压，放入本地 OpenClaw 的 skills 目录。',

    section3Title: '如何使用',
    step1Title: '登录 weryai.com 并创建 API Key',
    step1Warning: '请保管好API Key，勿轻易泄露。',
    step2Title: '通过 OpenClaw 完成 API 配置后发送消息内容。',
    step2CodePrefix: '消息内容：可参考下图示意',

    ex1User: '生成一个美女和咖啡的图片',
    ex1Bot1: '我直接帮你生成一张。',
    ex1Bot2: '好了，已生成 ✅',
    ex1LinkLabel: '图片链接：',
    ex1Bot3: '如果你要，我可以再给你出两版不同风格（写实/电影感）供你选。',
    ex1Alt: '示例配图',

    ex2User: '使用Werydance2.0 生个美女跳舞视频',
    ex2Bot1: '好，我按你指定的Werydance2.0直接生成。',
    ex2Bot2: '生成好了 ✅ (模型：Werydance2.0)',
    ex2LinkLabel: '视频链接：',
    ex2Bot3: '如果你要，我可以再出一版“更科技感舞台灯光”或“街舞风”做对比。',
    ex2Alt: '示例视频画面',
    ex2Badge: 'GIF',

    ex3User: '给我生成个中文版的介绍 WeryAI 的播客',
    ex3Bot1: '我直接用中文双人主播给你生成一版介绍 WeryAI 的播客。',
    ex3Bot2: '已生成完成，中文版 WeryAI 介绍播客在这：',
    ex3AudioLabel: '播客音频 (MP3)',
    ex3ParamsTitle: '本次参数：',
    ex3ParamLang: '语言：',
    ex3ParamMode: '模式：',
    ex3ParamHosts: '主播：',
    ex3ParamTaskId: '任务ID：',
    ex3HostsValue: '晓曼 + 苏哲',
    ex3Bot4: '如果你要，我可以再给你做一版更短的（60-90秒）营销口播版。',
    ex3Filename: 'weryai_880c86f898ef76daea513e260046a21e.mp3',
    ex3Time: '0:07',

    linkPlaceholder: 'https://static.weryai.com/...',
    demoSlug: 'weryai-video-generator',
    demoInstallUrl:
        'https://clawhub.ai/WeryAI-Developer/weryai-video-generator',
}

const tw = {
    skillsH1: 'WeryAI 官方 Skills',
    skillsPageTitle: 'WeryAI 官方 Skills',
    skillsIntro:
        'WeryAI 提供的官方 Skills 外掛，協助您在各類 AI 助手平台（如 OpenClaw／龍蝦）中快速整合並使用 WeryAI 的強大能力。',

    section1Title: 'Skills 功能介紹',
    clawHubMore: '查看WeryAI平台的Skills詳情',
    colSlug: 'Skill Slug',
    colFeature: '功能',
    colUrl: 'ClawHub 連結',

    featVideoGen: '影片生成',
    featImageGen: '圖片生成',
    featMusicGen: '音樂生成',
    featPodcastGen: 'Podcast 生成',
    featVideoEdit: '影片編輯',
    featImageEdit: '圖片編輯',
    featAccount: 'API 帳號積分餘額查詢',

    section2Title: '如何安裝',
    method1Title: '方法一',
    method1Hint: '告訴你的龍蝦 🦞：',
    method1LinePrefix: '安裝 Skill：',

    method2Title: '方法二',
    method2Hint: '告訴你的龍蝦 🦞：',
    method2Line1: '安裝這個 Skill：',

    method3Title: '方法三',
    method3Hint:
        '前往 ClawHub 搜尋 weryai 並下載壓縮包。',
    method3Box:
        '將壓縮包解壓，放入本機 OpenClaw 的 skills 目錄。',

    section3Title: '如何使用',
    step1Title: '登入 weryai.com 並建立 API Key',
    step1Warning: '請保管好API Key，勿輕易外洩。',
    step2Title: '透過 OpenClaw 完成 API 設定後傳送訊息內容。',
    step2CodePrefix: '訊息內容：可參考下方示意圖',

    ex1User: '生成一張美女與咖啡的圖片',
    ex1Bot1: '我直接幫你生成一張。',
    ex1Bot2: '好了，已生成 ✅',
    ex1LinkLabel: '圖片連結：',
    ex1Bot3: '若需要，我可以再提供兩種不同風格（寫實／電影感）供你選擇。',
    ex1Alt: '示例配圖',

    ex2User: '使用Werydance2.0 生成美女跳舞影片',
    ex2Bot1: '好的，我依你指定的Werydance2.0直接生成。',
    ex2Bot2: '生成完成 ✅（模型：Werydance2.0）',
    ex2LinkLabel: '影片連結：',
    ex2Bot3: '若需要，我可以再做一版「更科技感舞台燈光」或「街舞風」對照。',
    ex2Alt: '示例影片畫面',
    ex2Badge: 'GIF',

    ex3User: '幫我生成中文版介紹 WeryAI 的 Podcast',
    ex3Bot1: '我直接用中文雙人主播幫你生成一版介紹 WeryAI 的 Podcast。',
    ex3Bot2: '已生成完成，中文版 WeryAI 介紹 Podcast 在這：',
    ex3AudioLabel: 'Podcast 音訊 (MP3)',
    ex3ParamsTitle: '本次參數：',
    ex3ParamLang: '語言：',
    ex3ParamMode: '模式：',
    ex3ParamHosts: '主播：',
    ex3ParamTaskId: '任務 ID：',
    ex3HostsValue: '曉曼 + 蘇哲',
    ex3Bot4: '若需要，我可以再做一版更短（60–90 秒）的行銷口播版。',
    ex3Filename: 'weryai_880c86f898ef76daea513e260046a21e.mp3',
    ex3Time: '0:07',

    linkPlaceholder: 'https://static.weryai.com/...',
    demoSlug: 'weryai-video-generator',
    demoInstallUrl:
        'https://clawhub.ai/WeryAI-Developer/weryai-video-generator',
}

const ja = {
    skillsH1: 'WeryAI 公式 Skills',
    skillsPageTitle: 'WeryAI 公式 Skills',
    skillsIntro:
        'WeryAI の公式 Skills を使うと、OpenClaw などの AI アシスタントで WeryAI の生成 API をすばやく利用できます。',

    section1Title: 'Skills 機能紹介',
    clawHubMore: 'WeryAI プラットフォームで Skills の詳細を見る',
    colSlug: 'Skill slug',
    colFeature: '機能',
    colUrl: 'ClawHub リンク',

    featVideoGen: '動画生成',
    featImageGen: '画像生成',
    featMusicGen: '音楽生成',
    featPodcastGen: 'ポッドキャスト生成',
    featVideoEdit: '動画編集',
    featImageEdit: '画像編集',
    featAccount: 'API 残高・クレジット',

    section2Title: 'インストール方法',
    method1Title: '方法 1',
    method1Hint: 'アシスタント 🦞 に伝えてください：',
    method1LinePrefix: 'Skill をインストール：',

    method2Title: '方法 2',
    method2Hint: 'アシスタント 🦞 に伝えてください：',
    method2Line1: 'この Skill をインストール：',

    method3Title: '方法 3',
    method3Hint:
        'ClawHub で weryai を検索し、ZIP をダウンロードします。',
    method3Box:
        'ZIP を解凍し、ローカルの OpenClaw の skills フォルダに配置します。',

    section3Title: '使い方',
    step1Title: 'weryai.com にログインし API Key を作成',
    step1Warning: 'API Key は大切に保管し、安易に漏らさないでください。',
    step2Title:
        'OpenClaw で API 設定を完了したら、メッセージ内容を送信します。',
    step2CodePrefix: 'メッセージ内容：下の図を参考にしてください。',

    ex1User: '女性とコーヒーの画像を生成して。',
    ex1Bot1: 'すぐに生成します。',
    ex1Bot2: '完了しました — 生成成功 ✅',
    ex1LinkLabel: '画像 URL：',
    ex1Bot3:
        'リアル／シネマ風など、別バリエーションも 2 つ用意できます。',
    ex1Alt: 'サンプル画像',

    ex2User: 'Werydance2.0 でダンス動画を生成して。',
    ex2Bot1: '指定どおり Werydance2.0 で生成します。',
    ex2Bot2: '完了 ✅（モデル：Werydance2.0）',
    ex2LinkLabel: '動画 URL：',
    ex2Bot3:
        'テックなステージ照明版やストリートダンス風の版も試せます。',
    ex2Alt: 'サンプル動画フレーム',
    ex2Badge: 'GIF',

    ex3User: 'WeryAI を紹介する中国語ポッドキャストを生成して。',
    ex3Bot1:
        '中国語の二名ホストで weryai.com を紹介するポッドキャストを生成します。',
    ex3Bot2: '中国語イントロ版はこちらです：',
    ex3AudioLabel: 'ポッドキャスト音声 (MP3)',
    ex3ParamsTitle: 'パラメータ：',
    ex3ParamLang: '言語：',
    ex3ParamMode: 'モード：',
    ex3ParamHosts: 'ホスト：',
    ex3ParamTaskId: 'タスク ID：',
    ex3HostsValue: 'Xiaoman + Suzhe',
    ex3Bot4: '60〜90 秒の短いプロモ版も作成できます。',
    ex3Filename: 'weryai_880c86f898ef76daea513e260046a21e.mp3',
    ex3Time: '0:07',

    linkPlaceholder: 'https://static.weryai.com/...',
    demoSlug: 'weryai-video-generator',
    demoInstallUrl:
        'https://clawhub.ai/WeryAI-Developer/weryai-video-generator',
}

const ko = {
    skillsH1: 'WeryAI 공식 Skills',
    skillsPageTitle: 'WeryAI 공식 Skills',
    skillsIntro:
        'WeryAI 공식 Skills로 OpenClaw 등 AI 어시스턴트 플랫폼에서 WeryAI 생성 API를 빠르게 사용할 수 있습니다.',

    section1Title: 'Skills 기능 소개',
    clawHubMore: 'WeryAI 플랫폼에서 Skills 상세 보기',
    colSlug: 'Skill slug',
    colFeature: '기능',
    colUrl: 'ClawHub 링크',

    featVideoGen: '영상 생성',
    featImageGen: '이미지 생성',
    featMusicGen: '음악 생성',
    featPodcastGen: '팟캐스트 생성',
    featVideoEdit: '영상 편집',
    featImageEdit: '이미지 편집',
    featAccount: 'API 잔액 및 크레딧',

    section2Title: '설치 방법',
    method1Title: '방법 1',
    method1Hint: '어시스턴트 🦞에게 말하세요:',
    method1LinePrefix: 'Skill 설치:',

    method2Title: '방법 2',
    method2Hint: '어시스턴트 🦞에게 말하세요:',
    method2Line1: '이 Skill 설치:',

    method3Title: '방법 3',
    method3Hint:
        'ClawHub에서 weryai를 검색해 ZIP을 다운로드하세요.',
    method3Box:
        '압축을 풀고 로컬 OpenClaw의 skills 폴더에 넣습니다.',

    section3Title: '사용 방법',
    step1Title: 'weryai.com에 로그인하고 API Key 생성',
    step1Warning: 'API Key를 잘 보관하고 쉽게 노출하지 마세요.',
    step2Title:
        'OpenClaw에서 API 설정을 완료한 뒤 메시지 내용을 보냅니다.',
    step2CodePrefix: '메시지 내용: 아래 그림을 참고하세요.',

    ex1User: '여성과 커피 이미지를 생성해 줘.',
    ex1Bot1: '바로 생성해 드릴게요.',
    ex1Bot2: '완료 — 생성 성공 ✅',
    ex1LinkLabel: '이미지 URL:',
    ex1Bot3:
        '사실적/시네마틱 등 다른 스타일 두 가지도 드릴 수 있어요.',
    ex1Alt: '샘플 이미지',

    ex2User: 'Werydance2.0 으로 댄스 영상을 생성해 줘.',
    ex2Bot1: '요청하신 대로 Werydance2.0으로 생성합니다.',
    ex2Bot2: '완료 ✅ (모델: Werydance2.0)',
    ex2LinkLabel: '영상 URL:',
    ex2Bot3:
        '테크 스테이지 조명 버전이나 스트릿댄스 느낌 버전도 만들 수 있어요.',
    ex2Alt: '샘플 영상 프레임',
    ex2Badge: 'GIF',

    ex3User: 'www.weryai.com을 소개하는 중국어 팟캐스트를 생성해 줘.',
    ex3Bot1:
        '중국어 두 명 호스트로 weryai.com 소개 팟캐스트를 생성합니다.',
    ex3Bot2: '중국어 인트로 팟캐스트는 여기입니다:',
    ex3AudioLabel: '팟캐스트 오디오 (MP3)',
    ex3ParamsTitle: '매개변수:',
    ex3ParamLang: '언어:',
    ex3ParamMode: '모드:',
    ex3ParamHosts: '호스트:',
    ex3ParamTaskId: '작업 ID:',
    ex3HostsValue: 'Xiaoman + Suzhe',
    ex3Bot4: '60–90초 짧은 프로모 영상도 만들 수 있어요.',
    ex3Filename: 'weryai_880c86f898ef76daea513e260046a21e.mp3',
    ex3Time: '0:07',

    linkPlaceholder: 'https://static.weryai.com/...',
    demoSlug: 'weryai-video-generator',
    demoInstallUrl:
        'https://clawhub.ai/WeryAI-Developer/weryai-video-generator',
}

const es = {
    skillsH1: 'Skills oficiales de WeryAI',
    skillsPageTitle: 'Skills oficiales de WeryAI',
    skillsIntro:
        'Los Skills oficiales de WeryAI te permiten integrar WeryAI rápidamente en plataformas de asistentes de IA como OpenClaw y usar nuestras APIs de generación.',

    section1Title: 'Resumen de Skills',
    clawHubMore: 'Ver detalles de Skills en la plataforma WeryAI',
    colSlug: 'Skill slug',
    colFeature: 'Función',
    colUrl: 'Enlace de ClawHub',

    featVideoGen: 'Generación de vídeo',
    featImageGen: 'Generación de imagen',
    featMusicGen: 'Generación de música',
    featPodcastGen: 'Generación de podcast',
    featVideoEdit: 'Edición de vídeo',
    featImageEdit: 'Edición de imagen',
    featAccount: 'Saldo y créditos de API',

    section2Title: 'Cómo instalar',
    method1Title: 'Método 1',
    method1Hint: 'Díselo a tu asistente 🦞:',
    method1LinePrefix: 'Instalar Skill:',

    method2Title: 'Método 2',
    method2Hint: 'Díselo a tu asistente 🦞:',
    method2Line1: 'Instala este Skill:',

    method3Title: 'Método 3',
    method3Hint:
        'Ve a ClawHub, busca weryai y descarga el archivo ZIP.',
    method3Box:
        'Descomprime el archivo y colócalo en la carpeta skills de OpenClaw en local.',

    section3Title: 'Cómo usar',
    step1Title: 'Inicia sesión en weryai.com y crea una API Key',
    step1Warning: 'Guarda bien tu API Key y no la divulgues fácilmente.',
    step2Title:
        'Tras completar la configuración de la API en OpenClaw, envía el contenido del mensaje.',
    step2CodePrefix: 'Contenido del mensaje: consulta la ilustración inferior.',

    ex1User: 'Genera una imagen de una mujer con café.',
    ex1Bot1: 'Te la genero ahora mismo.',
    ex1Bot2: 'Listo — generado correctamente ✅',
    ex1LinkLabel: 'URL de la imagen:',
    ex1Bot3:
        'También puedo ofrecerte dos estilos más (realista / cinematográfico).',
    ex1Alt: 'Imagen de ejemplo',

    ex2User: 'Usa Werydance2.0 para generar un vídeo de baile.',
    ex2Bot1: 'Generando con Werydance2.0 como pediste.',
    ex2Bot2: 'Listo ✅ (modelo: Werydance2.0)',
    ex2LinkLabel: 'URL del vídeo:',
    ex2Bot3:
        'También puedo probar una versión con más “luz de escenario tech” o estilo street dance.',
    ex2Alt: 'Fotograma de ejemplo',
    ex2Badge: 'GIF',

    ex3User: 'Genera un podcast en chino que presente WeryAI.',
    ex3Bot1:
        'Generaré un podcast en chino con dos presentadores que presentan weryai.com.',
    ex3Bot2: 'Aquí está el podcast introductorio en chino:',
    ex3AudioLabel: 'Audio del podcast (MP3)',
    ex3ParamsTitle: 'Parámetros:',
    ex3ParamLang: 'Idioma:',
    ex3ParamMode: 'Modo:',
    ex3ParamHosts: 'Presentadores:',
    ex3ParamTaskId: 'ID de tarea:',
    ex3HostsValue: 'Xiaoman + Suzhe',
    ex3Bot4: 'También puedo hacer un corte promocional más corto de 60–90 s.',
    ex3Filename: 'weryai_880c86f898ef76daea513e260046a21e.mp3',
    ex3Time: '0:07',

    linkPlaceholder: 'https://static.weryai.com/...',
    demoSlug: 'weryai-video-generator',
    demoInstallUrl:
        'https://clawhub.ai/WeryAI-Developer/weryai-video-generator',
}

const fr = {
    skillsH1: 'Skills officiels WeryAI',
    skillsPageTitle: 'Skills officiels WeryAI',
    skillsIntro:
        'Les Skills officiels WeryAI vous permettent d’intégrer rapidement WeryAI sur des plateformes d’assistants IA comme OpenClaw et d’utiliser nos APIs de génération.',

    section1Title: 'Présentation des Skills',
    clawHubMore: 'Voir les détails des Skills sur la plateforme WeryAI',
    colSlug: 'Skill slug',
    colFeature: 'Fonction',
    colUrl: 'Lien ClawHub',

    featVideoGen: 'Génération vidéo',
    featImageGen: 'Génération d’images',
    featMusicGen: 'Génération de musique',
    featPodcastGen: 'Génération de podcast',
    featVideoEdit: 'Montage vidéo',
    featImageEdit: 'Retouche d’image',
    featAccount: 'Solde API et crédits',

    section2Title: 'Installation',
    method1Title: 'Méthode 1',
    method1Hint: 'Dites-le à votre assistant 🦞 :',
    method1LinePrefix: 'Installer le Skill :',

    method2Title: 'Méthode 2',
    method2Hint: 'Dites-le à votre assistant 🦞 :',
    method2Line1: 'Installer ce Skill :',

    method3Title: 'Méthode 3',
    method3Hint:
        'Allez sur ClawHub, recherchez weryai et téléchargez l’archive ZIP.',
    method3Box:
        'Décompressez l’archive et placez-la dans le dossier skills d’OpenClaw en local.',

    section3Title: 'Utilisation',
    step1Title: 'Connectez-vous sur weryai.com et créez une API Key',
    step1Warning: 'Conservez bien votre API Key et ne la divulguez pas facilement.',
    step2Title:
        'Après avoir terminé la configuration API dans OpenClaw, envoyez le contenu du message.',
    step2CodePrefix: 'Contenu du message : voir l’illustration ci-dessous.',

    ex1User: 'Génère une image d’une femme avec un café.',
    ex1Bot1: 'Je génère tout de suite.',
    ex1Bot2: 'Terminé — génération réussie ✅',
    ex1LinkLabel: 'URL de l’image :',
    ex1Bot3:
        'Je peux aussi proposer deux variantes (réaliste / cinématique).',
    ex1Alt: 'Image d’exemple',

    ex2User: 'Utilise Werydance2.0 pour générer une vidéo de danse.',
    ex2Bot1: 'Génération avec Werydance2.0 comme demandé.',
    ex2Bot2: 'Terminé ✅ (modèle : Werydance2.0)',
    ex2LinkLabel: 'URL de la vidéo :',
    ex2Bot3:
        'Je peux aussi tester une version « lumières de scène tech » ou street dance.',
    ex2Alt: 'Image vidéo d’exemple',
    ex2Badge: 'GIF',

    ex3User: 'Génère un podcast en chinois présentant WeryAI.',
    ex3Bot1:
        'Je génère un podcast en chinois à deux voix présentant weryai.com.',
    ex3Bot2: 'Voici le podcast d’intro en chinois :',
    ex3AudioLabel: 'Audio podcast (MP3)',
    ex3ParamsTitle: 'Paramètres :',
    ex3ParamLang: 'Langue :',
    ex3ParamMode: 'Mode :',
    ex3ParamHosts: 'Animateurs :',
    ex3ParamTaskId: 'ID de tâche :',
    ex3HostsValue: 'Xiaoman + Suzhe',
    ex3Bot4: 'Je peux aussi faire une version promo plus courte (60–90 s).',
    ex3Filename: 'weryai_880c86f898ef76daea513e260046a21e.mp3',
    ex3Time: '0:07',

    linkPlaceholder: 'https://static.weryai.com/...',
    demoSlug: 'weryai-video-generator',
    demoInstallUrl:
        'https://clawhub.ai/WeryAI-Developer/weryai-video-generator',
}

const de = {
    skillsH1: 'Offizielle WeryAI Skills',
    skillsPageTitle: 'Offizielle WeryAI Skills',
    skillsIntro:
        'Mit den offiziellen WeryAI Skills können Sie WeryAI schnell in KI-Assistenten wie OpenClaw einbinden und unsere Generierungs-APIs nutzen.',

    section1Title: 'Skills-Überblick',
    clawHubMore: 'Skills-Details auf der WeryAI-Plattform ansehen',
    colSlug: 'Skill slug',
    colFeature: 'Funktion',
    colUrl: 'ClawHub-Link',

    featVideoGen: 'Videogenerierung',
    featImageGen: 'Bildgenerierung',
    featMusicGen: 'Musikgenerierung',
    featPodcastGen: 'Podcast-Generierung',
    featVideoEdit: 'Videobearbeitung',
    featImageEdit: 'Bildbearbeitung',
    featAccount: 'API-Guthaben & Credits',

    section2Title: 'Installation',
    method1Title: 'Methode 1',
    method1Hint: 'Sagen Sie Ihrem Assistenten 🦞:',
    method1LinePrefix: 'Skill installieren:',

    method2Title: 'Methode 2',
    method2Hint: 'Sagen Sie Ihrem Assistenten 🦞:',
    method2Line1: 'Diesen Skill installieren:',

    method3Title: 'Methode 3',
    method3Hint:
        'Gehen Sie zu ClawHub, suchen Sie nach weryai und laden Sie das ZIP herunter.',
    method3Box:
        'Entpacken Sie das Archiv und legen Sie es in Ihr lokales OpenClaw-skills-Verzeichnis.',

    section3Title: 'Verwendung',
    step1Title: 'Bei weryai.com anmelden und API Key erstellen',
    step1Warning: 'Bewahren Sie Ihren API Key sicher auf und geben Sie ihn nicht leichtfertig preis.',
    step2Title:
        'Nach Abschluss der API-Konfiguration in OpenClaw Nachrichteninhalt senden.',
    step2CodePrefix: 'Nachrichteninhalt: siehe die Abbildung unten.',

    ex1User: 'Erzeuge ein Bild einer Frau mit Kaffee.',
    ex1Bot1: 'Ich generiere es sofort.',
    ex1Bot2: 'Fertig — erfolgreich erzeugt ✅',
    ex1LinkLabel: 'Bild-URL:',
    ex1Bot3:
        'Ich kann auch zwei weitere Stile (realistisch / filmisch) anbieten.',
    ex1Alt: 'Beispielbild',

    ex2User: 'Nutze Werydance2.0 für ein Tanzvideo.',
    ex2Bot1: 'Generiere mit Werydance2.0 wie gewünscht.',
    ex2Bot2: 'Fertig ✅ (Modell: Werydance2.0)',
    ex2LinkLabel: 'Video-URL:',
    ex2Bot3:
        'Ich kann auch eine Version mit „Tech-Bühnenlicht“ oder Street-Dance-Stil.',
    ex2Alt: 'Beispiel-Videoframe',
    ex2Badge: 'GIF',

    ex3User: 'Erzeuge einen chinesischen Podcast über WeryAI.',
    ex3Bot1:
        'Ich erzeuge einen zweistimmigen chinesischen Podcast zu weryai.com.',
    ex3Bot2: 'Hier ist der chinesische Intro-Podcast:',
    ex3AudioLabel: 'Podcast-Audio (MP3)',
    ex3ParamsTitle: 'Parameter:',
    ex3ParamLang: 'Sprache:',
    ex3ParamMode: 'Modus:',
    ex3ParamHosts: 'Hosts:',
    ex3ParamTaskId: 'Task-ID:',
    ex3HostsValue: 'Xiaoman + Suzhe',
    ex3Bot4: 'Ich kann auch einen kürzeren 60–90s Promo-Schnitt machen.',
    ex3Filename: 'weryai_880c86f898ef76daea513e260046a21e.mp3',
    ex3Time: '0:07',

    linkPlaceholder: 'https://static.weryai.com/...',
    demoSlug: 'weryai-video-generator',
    demoInstallUrl:
        'https://clawhub.ai/WeryAI-Developer/weryai-video-generator',
}

const ru = {
    skillsH1: 'Официальные Skills WeryAI',
    skillsPageTitle: 'Официальные Skills WeryAI',
    skillsIntro:
        'Официальные Skills WeryAI помогают быстро подключить WeryAI на платформах AI-ассистентов, таких как OpenClaw, и использовать наши API генерации.',

    section1Title: 'Обзор Skills',
    clawHubMore: 'Смотреть подробности Skills на платформе WeryAI',
    colSlug: 'Skill slug',
    colFeature: 'Функция',
    colUrl: 'Ссылка ClawHub',

    featVideoGen: 'Генерация видео',
    featImageGen: 'Генерация изображений',
    featMusicGen: 'Генерация музыки',
    featPodcastGen: 'Генерация подкаста',
    featVideoEdit: 'Редактирование видео',
    featImageEdit: 'Редактирование изображений',
    featAccount: 'Баланс API и кредиты',

    section2Title: 'Как установить',
    method1Title: 'Способ 1',
    method1Hint: 'Скажите ассистенту 🦞:',
    method1LinePrefix: 'Установить Skill:',

    method2Title: 'Способ 2',
    method2Hint: 'Скажите ассистенту 🦞:',
    method2Line1: 'Установить этот Skill:',

    method3Title: 'Способ 3',
    method3Hint:
        'Перейдите на ClawHub, найдите weryai и скачайте ZIP-архив.',
    method3Box:
        'Распакуйте архив и поместите в локальную папку skills OpenClaw.',

    section3Title: 'Как использовать',
    step1Title: 'Войдите на weryai.com и создайте API Key',
    step1Warning: 'Надёжно храните API Key и не раскрывайте его без необходимости.',
    step2Title:
        'После завершения настройки API в OpenClaw отправьте текст сообщения.',
    step2CodePrefix: 'Содержимое сообщения: см. иллюстрацию ниже.',

    ex1User: 'Сгенерируй изображение женщины с кофе.',
    ex1Bot1: 'Сейчас сгенерирую.',
    ex1Bot2: 'Готово — успешно сгенерировано ✅',
    ex1LinkLabel: 'URL изображения:',
    ex1Bot3:
        'Могу предложить ещё два стиля (реалистичный / киношный).',
    ex1Alt: 'Пример изображения',

    ex2User: 'Сгенерируй танцевальное видео через Werydance2.0 .',
    ex2Bot1: 'Генерирую через Werydance2.0, как вы просили.',
    ex2Bot2: 'Готово ✅ (модель: Werydance2.0)',
    ex2LinkLabel: 'URL видео:',
    ex2Bot3:
        'Могу также сделать версию с «техно-светом сцены» или в стиле стрит-данса.',
    ex2Alt: 'Кадр примера',
    ex2Badge: 'GIF',

    ex3User: 'Сгенерируй китайский подкаст о WeryAI.',
    ex3Bot1:
        'Сгенерирую китайский подкаст с двумя ведущими о weryai.com.',
    ex3Bot2: 'Вот вступительный подкаст на китайском:',
    ex3AudioLabel: 'Аудио подкаста (MP3)',
    ex3ParamsTitle: 'Параметры:',
    ex3ParamLang: 'Язык:',
    ex3ParamMode: 'Режим:',
    ex3ParamHosts: 'Ведущие:',
    ex3ParamTaskId: 'ID задачи:',
    ex3HostsValue: 'Xiaoman + Suzhe',
    ex3Bot4: 'Могу также сделать короткий промо-ролик 60–90 с.',
    ex3Filename: 'weryai_880c86f898ef76daea513e260046a21e.mp3',
    ex3Time: '0:07',

    linkPlaceholder: 'https://static.weryai.com/...',
    demoSlug: 'weryai-video-generator',
    demoInstallUrl:
        'https://clawhub.ai/WeryAI-Developer/weryai-video-generator',
}

const pt = {
    skillsH1: 'Skills oficiais da WeryAI',
    skillsPageTitle: 'Skills oficiais da WeryAI',
    skillsIntro:
        'Os Skills oficiais da WeryAI permitem integrar rapidamente a WeryAI em plataformas de assistentes de IA como o OpenClaw e usar nossas APIs de geração.',

    section1Title: 'Visão geral dos Skills',
    clawHubMore: 'Ver detalhes dos Skills na plataforma WeryAI',
    colSlug: 'Skill slug',
    colFeature: 'Função',
    colUrl: 'Link do ClawHub',

    featVideoGen: 'Geração de vídeo',
    featImageGen: 'Geração de imagem',
    featMusicGen: 'Geração de música',
    featPodcastGen: 'Geração de podcast',
    featVideoEdit: 'Edição de vídeo',
    featImageEdit: 'Edição de imagem',
    featAccount: 'Saldo e créditos da API',

    section2Title: 'Como instalar',
    method1Title: 'Método 1',
    method1Hint: 'Diga ao seu assistente 🦞:',
    method1LinePrefix: 'Instalar Skill:',

    method2Title: 'Método 2',
    method2Hint: 'Diga ao seu assistente 🦞:',
    method2Line1: 'Instalar este Skill:',

    method3Title: 'Método 3',
    method3Hint:
        'Acesse o ClawHub, pesquise weryai e baixe o arquivo ZIP.',
    method3Box:
        'Descompacte o arquivo e coloque na pasta skills do OpenClaw local.',

    section3Title: 'Como usar',
    step1Title: 'Entre em weryai.com e crie uma API Key',
    step1Warning: 'Guarde bem sua API Key e não a divulgue com facilidade.',
    step2Title:
        'Após concluir a configuração da API no OpenClaw, envie o conteúdo da mensagem.',
    step2CodePrefix: 'Conteúdo da mensagem: veja a ilustração abaixo.',

    ex1User: 'Gere uma imagem de uma mulher com café.',
    ex1Bot1: 'Vou gerar agora mesmo.',
    ex1Bot2: 'Pronto — gerado com sucesso ✅',
    ex1LinkLabel: 'URL da imagem:',
    ex1Bot3:
        'Também posso oferecer dois estilos (realista / cinematográfico).',
    ex1Alt: 'Imagem de exemplo',

    ex2User: 'Use o Werydance2.0 para gerar um vídeo de dança.',
    ex2Bot1: 'Gerando com Werydance2.0 conforme pedido.',
    ex2Bot2: 'Pronto ✅ (modelo: Werydance2.0)',
    ex2LinkLabel: 'URL do vídeo:',
    ex2Bot3:
        'Também posso tentar uma versão com mais “luz de palco tech” ou estilo street dance.',
    ex2Alt: 'Quadro de exemplo',
    ex2Badge: 'GIF',

    ex3User: 'Gere um podcast em chinês apresentando WeryAI.',
    ex3Bot1:
        'Vou gerar um podcast em chinês com dois apresentadores sobre weryai.com.',
    ex3Bot2: 'Aqui está o podcast de introdução em chinês:',
    ex3AudioLabel: 'Áudio do podcast (MP3)',
    ex3ParamsTitle: 'Parâmetros:',
    ex3ParamLang: 'Idioma:',
    ex3ParamMode: 'Modo:',
    ex3ParamHosts: 'Apresentadores:',
    ex3ParamTaskId: 'ID da tarefa:',
    ex3HostsValue: 'Xiaoman + Suzhe',
    ex3Bot4: 'Também posso fazer um corte promocional mais curto de 60–90 s.',
    ex3Filename: 'weryai_880c86f898ef76daea513e260046a21e.mp3',
    ex3Time: '0:07',

    linkPlaceholder: 'https://static.weryai.com/...',
    demoSlug: 'weryai-video-generator',
    demoInstallUrl:
        'https://clawhub.ai/WeryAI-Developer/weryai-video-generator',
}

const it = {
    skillsH1: 'Skills ufficiali WeryAI',
    skillsPageTitle: 'Skills ufficiali WeryAI',
    skillsIntro:
        'Gli Skills ufficiali WeryAI ti permettono di integrare rapidamente WeryAI su piattaforme di assistenti AI come OpenClaw e usare le nostre API di generazione.',

    section1Title: 'Panoramica Skills',
    clawHubMore: 'Vedi i dettagli degli Skills sulla piattaforma WeryAI',
    colSlug: 'Skill slug',
    colFeature: 'Funzione',
    colUrl: 'Link ClawHub',

    featVideoGen: 'Generazione video',
    featImageGen: 'Generazione immagini',
    featMusicGen: 'Generazione musica',
    featPodcastGen: 'Generazione podcast',
    featVideoEdit: 'Modifica video',
    featImageEdit: 'Modifica immagini',
    featAccount: 'Saldo API e crediti',

    section2Title: 'Come installare',
    method1Title: 'Metodo 1',
    method1Hint: 'Di’ al tuo assistente 🦞:',
    method1LinePrefix: 'Installa Skill:',

    method2Title: 'Metodo 2',
    method2Hint: 'Di’ al tuo assistente 🦞:',
    method2Line1: 'Installa questo Skill:',

    method3Title: 'Metodo 3',
    method3Hint:
        'Vai su ClawHub, cerca weryai e scarica lo ZIP.',
    method3Box:
        'Decomprimi l’archivio e metti nella cartella skills di OpenClaw in locale.',

    section3Title: 'Come usare',
    step1Title: 'Accedi a weryai.com e crea una API Key',
    step1Warning: 'Conserva bene la tua API Key e non divulgarla facilmente.',
    step2Title:
        'Dopo aver completato la configurazione API in OpenClaw, invia il contenuto del messaggio.',
    step2CodePrefix: 'Contenuto del messaggio: vedi l’illustrazione sotto.',

    ex1User: 'Genera un’immagine di una donna con il caffè.',
    ex1Bot1: 'La genero subito.',
    ex1Bot2: 'Fatto — generazione riuscita ✅',
    ex1LinkLabel: 'URL immagine:',
    ex1Bot3:
        'Posso anche offrire altri due stili (realistico / cinematografico).',
    ex1Alt: 'Immagine di esempio',

    ex2User: 'Usa Werydance2.0 per generare un video di danza.',
    ex2Bot1: 'Generazione con Werydance2.0 come richiesto.',
    ex2Bot2: 'Fatto ✅ (modello: Werydance2.0)',
    ex2LinkLabel: 'URL video:',
    ex2Bot3:
        'Posso anche provare una versione con più “luci da palco tech” o stile street dance.',
    ex2Alt: 'Fotogramma di esempio',
    ex2Badge: 'GIF',

    ex3User: 'Genera un podcast in cinese che presenta WeryAI.',
    ex3Bot1:
        'Genero un podcast in cinese con due conduttori su weryai.com.',
    ex3Bot2: 'Ecco il podcast introduttivo in cinese:',
    ex3AudioLabel: 'Audio podcast (MP3)',
    ex3ParamsTitle: 'Parametri:',
    ex3ParamLang: 'Lingua:',
    ex3ParamMode: 'Modalità:',
    ex3ParamHosts: 'Conduttori:',
    ex3ParamTaskId: 'ID attività:',
    ex3HostsValue: 'Xiaoman + Suzhe',
    ex3Bot4: 'Posso anche fare un promo più corto da 60–90 s.',
    ex3Filename: 'weryai_880c86f898ef76daea513e260046a21e.mp3',
    ex3Time: '0:07',

    linkPlaceholder: 'https://static.weryai.com/...',
    demoSlug: 'weryai-video-generator',
    demoInstallUrl:
        'https://clawhub.ai/WeryAI-Developer/weryai-video-generator',
}

const ar = {
    skillsH1: 'مهارات WeryAI الرسمية',
    skillsPageTitle: 'مهارات WeryAI الرسمية',
    skillsIntro:
        'تتيح لك مهارات WeryAI الرسمية دمج WeryAI بسرعة في منصات المساعدات الذكية مثل OpenClaw واستخدام واجهات التوليد الخاصة بنا.',

    section1Title: 'نظرة عامة على المهارات',
    clawHubMore: 'عرض تفاصيل Skills على منصة WeryAI',
    colSlug: 'Skill slug',
    colFeature: 'الميزة',
    colUrl: 'رابط ClawHub',

    featVideoGen: 'توليد فيديو',
    featImageGen: 'توليد صورة',
    featMusicGen: 'توليد موسيقى',
    featPodcastGen: 'توليد بودكاست',
    featVideoEdit: 'تحرير فيديو',
    featImageEdit: 'تحرير صورة',
    featAccount: 'رصيد API والأرصدة',

    section2Title: 'كيفية التثبيت',
    method1Title: 'الطريقة 1',
    method1Hint: 'قل لمساعدك 🦞:',
    method1LinePrefix: 'تثبيت Skill:',

    method2Title: 'الطريقة 2',
    method2Hint: 'قل لمساعدك 🦞:',
    method2Line1: 'ثبّت هذا Skill:',

    method3Title: 'الطريقة 3',
    method3Hint:
        'انتقل إلى ClawHub وابحث عن weryai وحمّل ملف ZIP.',
    method3Box:
        'فك ضغط الملف وضعه في مجلد skills لـ OpenClaw محليًا.',

    section3Title: 'كيفية الاستخدام',
    step1Title: 'سجّل الدخول إلى weryai.com وأنشئ API Key',
    step1Warning: 'يرجى حفظ API Key بعناية وعدم كشفه بسهولة.',
    step2Title:
        'بعد إكمال إعداد API في OpenClaw، أرسل محتوى الرسالة.',
    step2CodePrefix: 'محتوى الرسالة: راجع الرسم التوضيحي أدناه.',

    ex1User: 'ولّد صورة لامرأة مع قهوة.',
    ex1Bot1: 'سأولّدها الآن.',
    ex1Bot2: 'تم — اكتمل التوليد بنجاح ✅',
    ex1LinkLabel: 'رابط الصورة:',
    ex1Bot3: 'يمكنني أيضًا تقديم نسختين إضافيتين (واقعي / سينمائي).',
    ex1Alt: 'صورة توضيحية',

    ex2User: 'استخدم Werydance2.0 لتوليد فيديو رقص.',
    ex2Bot1: 'جارٍ التوليد بـ Werydance2.0 كما طلبت.',
    ex2Bot2: 'تم ✅ (النموذج: Werydance2.0)',
    ex2LinkLabel: 'رابط الفيديو:',
    ex2Bot3:
        'يمكنني أيضًا تجربة نسخة بإضاءة مسرح تقنية أو أسلوب رقص شوارع.',
    ex2Alt: 'إطار فيديو توضيحي',
    ex2Badge: 'GIF',

    ex3User: 'ولّد بودكاستًا بالصينية يقدّم WeryAI.',
    ex3Bot1:
        'سأولّد بودكاستًا بالصينية بمقدّمين يقدّمان weryai.com.',
    ex3Bot2: 'إليك البودكاست التمهيدي بالصينية:',
    ex3AudioLabel: 'صوت البودكاست (MP3)',
    ex3ParamsTitle: 'المعاملات:',
    ex3ParamLang: 'اللغة:',
    ex3ParamMode: 'الوضع:',
    ex3ParamHosts: 'المقدّمون:',
    ex3ParamTaskId: 'معرّف المهمة:',
    ex3HostsValue: 'Xiaoman + Suzhe',
    ex3Bot4: 'يمكنني أيضًا عمل قصّة ترويجية أقصر (60–90 ث).',
    ex3Filename: 'weryai_880c86f898ef76daea513e260046a21e.mp3',
    ex3Time: '0:07',

    linkPlaceholder: 'https://static.weryai.com/...',
    demoSlug: 'weryai-video-generator',
    demoInstallUrl:
        'https://clawhub.ai/WeryAI-Developer/weryai-video-generator',
}

const pl = {
    skillsH1: 'Oficjalne Skills WeryAI',
    skillsPageTitle: 'Oficjalne Skills WeryAI',
    skillsIntro:
        'Oficjalne Skills WeryAI pozwalają szybko zintegrować WeryAI z platformami asystentów AI, takimi jak OpenClaw, i korzystać z naszych API generacji.',

    section1Title: 'Przegląd Skills',
    clawHubMore: 'Zobacz szczegóły Skills na platformie WeryAI',
    colSlug: 'Skill slug',
    colFeature: 'Funkcja',
    colUrl: 'Link ClawHub',

    featVideoGen: 'Generowanie wideo',
    featImageGen: 'Generowanie obrazu',
    featMusicGen: 'Generowanie muzyki',
    featPodcastGen: 'Generowanie podcastu',
    featVideoEdit: 'Edycja wideo',
    featImageEdit: 'Edycja obrazu',
    featAccount: 'Saldo API i kredyty',

    section2Title: 'Jak zainstalować',
    method1Title: 'Metoda 1',
    method1Hint: 'Powiedz asystentowi 🦞:',
    method1LinePrefix: 'Zainstaluj Skill:',

    method2Title: 'Metoda 2',
    method2Hint: 'Powiedz asystentowi 🦞:',
    method2Line1: 'Zainstaluj ten Skill:',

    method3Title: 'Metoda 3',
    method3Hint:
        'Wejdź na ClawHub, wyszukaj weryai i pobierz archiwum ZIP.',
    method3Box:
        'Rozpakuj archiwum i umieść w lokalnym katalogu skills OpenClaw.',

    section3Title: 'Jak używać',
    step1Title: 'Zaloguj się na weryai.com i utwórz API Key',
    step1Warning: 'Przechowuj API Key bezpiecznie i nie ujawniaj go pochopnie.',
    step2Title:
        'Po zakończeniu konfiguracji API w OpenClaw wyślij treść wiadomości.',
    step2CodePrefix: 'Treść wiadomości: patrz ilustracja poniżej.',

    ex1User: 'Wygeneruj obraz kobiety z kawą.',
    ex1Bot1: 'Generuję od razu.',
    ex1Bot2: 'Gotowe — wygenerowano pomyślnie ✅',
    ex1LinkLabel: 'URL obrazu:',
    ex1Bot3:
        'Mogę też zaproponować dwa dodatkowe style (realistyczny / filmowy).',
    ex1Alt: 'Przykładowy obraz',

    ex2User: 'Użyj Werydance2.0, by wygenerować film taneczny.',
    ex2Bot1: 'Generuję przez Werydance2.0 zgodnie z prośbą.',
    ex2Bot2: 'Gotowe ✅ (model: Werydance2.0)',
    ex2LinkLabel: 'URL wideo:',
    ex2Bot3:
        'Mogę też spróbować wersji z mocniejszym „techowym” światłem sceny lub street dance.',
    ex2Alt: 'Przykładowa klatka',
    ex2Badge: 'GIF',

    ex3User: 'Wygeneruj podcast po chińsku przedstawiający WeryAI.',
    ex3Bot1:
        'Wygeneruję podcast po chińsku z dwoma prowadzącymi o weryai.com.',
    ex3Bot2: 'Oto wprowadzający podcast po chińsku:',
    ex3AudioLabel: 'Audio podcastu (MP3)',
    ex3ParamsTitle: 'Parametry:',
    ex3ParamLang: 'Język:',
    ex3ParamMode: 'Tryb:',
    ex3ParamHosts: 'Prowadzący:',
    ex3ParamTaskId: 'ID zadania:',
    ex3HostsValue: 'Xiaoman + Suzhe',
    ex3Bot4: 'Mogę też zrobić krótszy materiał promocyjny 60–90 s.',
    ex3Filename: 'weryai_880c86f898ef76daea513e260046a21e.mp3',
    ex3Time: '0:07',

    linkPlaceholder: 'https://static.weryai.com/...',
    demoSlug: 'weryai-video-generator',
    demoInstallUrl:
        'https://clawhub.ai/WeryAI-Developer/weryai-video-generator',
}

const th = {
    skillsH1: 'Skills ทางการของ WeryAI',
    skillsPageTitle: 'Skills ทางการของ WeryAI',
    skillsIntro:
        'Skills ทางการของ WeryAI ช่วยให้คุณเชื่อมต่อ WeryAI กับแพลตฟอร์มผู้ช่วย AI เช่น OpenClaw และใช้ API การสร้างของเราได้อย่างรวดเร็ว',

    section1Title: 'ภาพรวม Skills',
    clawHubMore: 'ดูรายละเอียด Skills บนแพลตฟอร์ม WeryAI',
    colSlug: 'Skill slug',
    colFeature: 'ความสามารถ',
    colUrl: 'ลิงก์ ClawHub',

    featVideoGen: 'สร้างวิดีโอ',
    featImageGen: 'สร้างภาพ',
    featMusicGen: 'สร้างเพลง',
    featPodcastGen: 'สร้างพอดแคสต์',
    featVideoEdit: 'ตัดต่อวิดีโอ',
    featImageEdit: 'แต่งภาพ',
    featAccount: 'ยอด API และเครดิต',

    section2Title: 'วิธีติดตั้ง',
    method1Title: 'วิธีที่ 1',
    method1Hint: 'บอกผู้ช่วย 🦞 ว่า:',
    method1LinePrefix: 'ติดตั้ง Skill:',

    method2Title: 'วิธีที่ 2',
    method2Hint: 'บอกผู้ช่วย 🦞 ว่า:',
    method2Line1: 'ติดตั้ง Skill นี้:',

    method3Title: 'วิธีที่ 3',
    method3Hint:
        'ไปที่ ClawHub ค้นหา weryai แล้วดาวน์โหลดไฟล์ ZIP',
    method3Box:
        'แตกไฟล์ ZIP แล้ววางในโฟลเดอร์ skills ของ OpenClaw บนเครื่อง',

    section3Title: 'วิธีใช้งาน',
    step1Title: 'ล็อกอินที่ weryai.com และสร้าง API Key',
    step1Warning: 'โปรดเก็บ API Key ให้ปลอดภัย และอย่าเปิดเผยโดยง่าย',
    step2Title:
        'หลังตั้งค่า API ใน OpenClaw เสร็จ ให้ส่งเนื้อหาข้อความ',
    step2CodePrefix: 'เนื้อหาข้อความ: ดูภาพประกอบด้านล่าง',

    ex1User: 'สร้างภาพผู้หญิงกับกาแฟ',
    ex1Bot1: 'กำลังสร้างให้เลย',
    ex1Bot2: 'เสร็จแล้ว — สร้างสำเร็จ ✅',
    ex1LinkLabel: 'ลิงก์ภาพ:',
    ex1Bot3:
        'ยังมีสไตล์ออปชันอีกสองแบบ (สมจริง / โทนภาพยนตร์) ได้',
    ex1Alt: 'ภาพตัวอย่าง',

    ex2User: 'ใช้ Werydance2.0 สร้างวิดีโอเต้น',
    ex2Bot1: 'กำลังสร้างด้วย Werydance2.0 ตามที่ขอ',
    ex2Bot2: 'เสร็จแล้ว ✅ (โมเดล: Werydance2.0)',
    ex2LinkLabel: 'ลิงก์วิดีโอ:',
    ex2Bot3:
        'ลองเวอร์ชันไฟเวทีเทคโนโลยีหรือสไตล์สตรีทแดนซ์ได้',
    ex2Alt: 'เฟรมวิดีโอตัวอย่าง',
    ex2Badge: 'GIF',

    ex3User: 'สร้างพอดแคสต์ภาษาจีนแนะนำ WeryAI',
    ex3Bot1:
        'จะสร้างพอดแคสต์ภาษาจีนสองพิธีกรแนะนำ weryai.com',
    ex3Bot2: 'นี่คือพอดแคสต์อินโทรภาษาจีน:',
    ex3AudioLabel: 'เสียงพอดแคสต์ (MP3)',
    ex3ParamsTitle: 'พารามิเตอร์:',
    ex3ParamLang: 'ภาษา:',
    ex3ParamMode: 'โหมด:',
    ex3ParamHosts: 'พิธีกร:',
    ex3ParamTaskId: 'รหัสงาน:',
    ex3HostsValue: 'Xiaoman + Suzhe',
    ex3Bot4: 'ทำเวอร์ชันโปรโมสั้น 60–90 วินาทีได้',
    ex3Filename: 'weryai_880c86f898ef76daea513e260046a21e.mp3',
    ex3Time: '0:07',

    linkPlaceholder: 'https://static.weryai.com/...',
    demoSlug: 'weryai-video-generator',
    demoInstallUrl:
        'https://clawhub.ai/WeryAI-Developer/weryai-video-generator',
}

const da = {
    skillsH1: 'WeryAI officielle Skills',
    skillsPageTitle: 'WeryAI officielle Skills',
    skillsIntro:
        'WeryAI officielle Skills gør det nemt at integrere WeryAI på AI-assistentplatforme som OpenClaw og bruge vores genererings-API’er.',

    section1Title: 'Skills oversigt',
    clawHubMore: 'Se Skills-detaljer på WeryAI-platformen',
    colSlug: 'Skill slug',
    colFeature: 'Funktion',
    colUrl: 'ClawHub-link',

    featVideoGen: 'Videogenerering',
    featImageGen: 'Billedgenerering',
    featMusicGen: 'Musikgenerering',
    featPodcastGen: 'Podcast-generering',
    featVideoEdit: 'Videoredigering',
    featImageEdit: 'Billedredigering',
    featAccount: 'API-saldo og credits',

    section2Title: 'Sådan installerer du',
    method1Title: 'Metode 1',
    method1Hint: 'Sig til din assistent 🦞:',
    method1LinePrefix: 'Installer Skill:',

    method2Title: 'Metode 2',
    method2Hint: 'Sig til din assistent 🦞:',
    method2Line1: 'Installer denne Skill:',

    method3Title: 'Metode 3',
    method3Hint:
        'Gå til ClawHub, søg efter weryai og download ZIP-filen.',
    method3Box:
        'Pak ZIP-filen ud og læg den i din lokale OpenClaw skills-mappe.',

    section3Title: 'Sådan bruger du',
    step1Title: 'Log ind på weryai.com og opret en API Key',
    step1Warning: 'Opbevar din API Key sikkert, og del den ikke let.',
    step2Title:
        'Når API-konfigurationen er fuldført i OpenClaw, send beskedindholdet.',
    step2CodePrefix: 'Beskedindhold: se illustrationen nedenfor.',

    ex1User: 'Generér et billede af en kvinde med kaffe.',
    ex1Bot1: 'Jeg genererer det nu.',
    ex1Bot2: 'Færdig — genereret ✅',
    ex1LinkLabel: 'Billede-URL:',
    ex1Bot3:
        'Jeg kan også tilbyde to mere (realistisk / filmisk).',
    ex1Alt: 'Eksempelbillede',

    ex2User: 'Brug Werydance2.0 til at generere en dansevideo.',
    ex2Bot1: 'Genererer med Werydance2.0 som ønsket.',
    ex2Bot2: 'Færdig ✅ (model: Werydance2.0)',
    ex2LinkLabel: 'Video-URL:',
    ex2Bot3:
        'Jeg kan også prøve en version med mere “tech” scenelys eller street dance.',
    ex2Alt: 'Eksempelvideoramme',
    ex2Badge: 'GIF',

    ex3User: 'Generér en kinesisk podcast om WeryAI.',
    ex3Bot1:
        'Jeg genererer en kinesisk podcast med to værter om weryai.com.',
    ex3Bot2: 'Her er den kinesiske intro-podcast:',
    ex3AudioLabel: 'Podcast-lyd (MP3)',
    ex3ParamsTitle: 'Parametre:',
    ex3ParamLang: 'Sprog:',
    ex3ParamMode: 'Tilstand:',
    ex3ParamHosts: 'Værter:',
    ex3ParamTaskId: 'Opgave-ID:',
    ex3HostsValue: 'Xiaoman + Suzhe',
    ex3Bot4: 'Jeg kan også lave et kortere 60–90s promo-klip.',
    ex3Filename: 'weryai_880c86f898ef76daea513e260046a21e.mp3',
    ex3Time: '0:07',

    linkPlaceholder: 'https://static.weryai.com/...',
    demoSlug: 'weryai-video-generator',
    demoInstallUrl:
        'https://clawhub.ai/WeryAI-Developer/weryai-video-generator',
}

const no = {
    skillsH1: 'WeryAI offisielle Skills',
    skillsPageTitle: 'WeryAI offisielle Skills',
    skillsIntro:
        'WeryAI offisielle Skills lar deg integrere WeryAI raskt på AI-assistentplattformer som OpenClaw og bruke våre genererings-API-er.',

    section1Title: 'Skills-oversikt',
    clawHubMore: 'Se Skills-detaljer på WeryAI-plattformen',
    colSlug: 'Skill slug',
    colFeature: 'Funksjon',
    colUrl: 'ClawHub-lenke',

    featVideoGen: 'Videogenerering',
    featImageGen: 'Bildegenerering',
    featMusicGen: 'Musikkgenerering',
    featPodcastGen: 'Podcast-generering',
    featVideoEdit: 'Videoredigering',
    featImageEdit: 'Bilderedigering',
    featAccount: 'API-saldo og credits',

    section2Title: 'Slik installerer du',
    method1Title: 'Metode 1',
    method1Hint: 'Si til assistenten 🦞:',
    method1LinePrefix: 'Installer Skill:',

    method2Title: 'Metode 2',
    method2Hint: 'Si til assistenten 🦞:',
    method2Line1: 'Installer denne Skill:',

    method3Title: 'Metode 3',
    method3Hint:
        'Gå til ClawHub, søk etter weryai og last ned ZIP-filen.',
    method3Box:
        'Pakk ut ZIP-filen og legg den i din lokale OpenClaw skills-mappe.',

    section3Title: 'Slik bruker du',
    step1Title: 'Logg inn på weryai.com og opprett en API Key',
    step1Warning: 'Oppbevar API Key trygt og ikke del den lett.',
    step2Title:
        'Når API-konfigurasjonen er fullført i OpenClaw, send meldingsinnholdet.',
    step2CodePrefix: 'Meldingsinnhold: se illustrasjonen nedenfor.',

    ex1User: 'Generer et bilde av en kvinne med kaffe.',
    ex1Bot1: 'Jeg genererer nå.',
    ex1Bot2: 'Ferdig — generert ✅',
    ex1LinkLabel: 'Bilde-URL:',
    ex1Bot3:
        'Jeg kan også tilby to flere stiler (realistisk / filmatisk).',
    ex1Alt: 'Eksempelbilde',

    ex2User: 'Bruk Werydance2.0 til å generere en dansevideo.',
    ex2Bot1: 'Genererer med Werydance2.0 som forespurt.',
    ex2Bot2: 'Ferdig ✅ (modell: Werydance2.0)',
    ex2LinkLabel: 'Video-URL:',
    ex2Bot3:
        'Jeg kan også prøve en versjon med mer «tech» scenelys eller street dance.',
    ex2Alt: 'Eksempelvideoramme',
    ex2Badge: 'GIF',

    ex3User: 'Generer en kinesisk podcast som presenterer WeryAI.',
    ex3Bot1:
        'Jeg genererer en kinesisk podcast med to verter om weryai.com.',
    ex3Bot2: 'Her er den kinesiske intro-podcasten:',
    ex3AudioLabel: 'Podcast-lyd (MP3)',
    ex3ParamsTitle: 'Parametere:',
    ex3ParamLang: 'Språk:',
    ex3ParamMode: 'Modus:',
    ex3ParamHosts: 'Verter:',
    ex3ParamTaskId: 'Oppgave-ID:',
    ex3HostsValue: 'Xiaoman + Suzhe',
    ex3Bot4: 'Jeg kan også lage et kortere 60–90s promo-klipp.',
    ex3Filename: 'weryai_880c86f898ef76daea513e260046a21e.mp3',
    ex3Time: '0:07',

    linkPlaceholder: 'https://static.weryai.com/...',
    demoSlug: 'weryai-video-generator',
    demoInstallUrl:
        'https://clawhub.ai/WeryAI-Developer/weryai-video-generator',
}

const nl = {
    skillsH1: 'Officiële WeryAI Skills',
    skillsPageTitle: 'Officiële WeryAI Skills',
    skillsIntro:
        'Met officiële WeryAI Skills integreer je WeryAI snel in AI-assistentplatformen zoals OpenClaw en gebruik je onze generatie-API’s.',

    section1Title: 'Skills-overzicht',
    clawHubMore: 'Bekijk Skills-details op het WeryAI-platform',
    colSlug: 'Skill slug',
    colFeature: 'Functie',
    colUrl: 'ClawHub-link',

    featVideoGen: 'Videogeneratie',
    featImageGen: 'Beeldgeneratie',
    featMusicGen: 'Muziekgeneratie',
    featPodcastGen: 'Podcastgeneratie',
    featVideoEdit: 'Videobewerking',
    featImageEdit: 'Beeldbewerking',
    featAccount: 'API-saldo en credits',

    section2Title: 'Installeren',
    method1Title: 'Methode 1',
    method1Hint: 'Zeg het tegen je assistent 🦞:',
    method1LinePrefix: 'Skill installeren:',

    method2Title: 'Methode 2',
    method2Hint: 'Zeg het tegen je assistent 🦞:',
    method2Line1: 'Deze Skill installeren:',

    method3Title: 'Methode 3',
    method3Hint:
        'Ga naar ClawHub, zoek op weryai en download het ZIP-bestand.',
    method3Box:
        'Pak het ZIP-bestand uit en plaats het in je lokale OpenClaw skills-map.',

    section3Title: 'Gebruik',
    step1Title: 'Log in op weryai.com en maak een API Key',
    step1Warning: 'Bewaar je API Key goed en deel deze niet zomaar.',
    step2Title:
        'Na het voltooien van de API-configuratie in OpenClaw, stuur de berichtinhoud.',
    step2CodePrefix: 'Berichtinhoud: zie de illustratie hieronder.',

    ex1User: 'Genereer een afbeelding van een vrouw met koffie.',
    ex1Bot1: 'Ik genereer het meteen.',
    ex1Bot2: 'Klaar — succesvol gegenereerd ✅',
    ex1LinkLabel: 'Afbeeldings-URL:',
    ex1Bot3:
        'Ik kan ook twee extra stijlen aanbieden (realistisch / filmisch).',
    ex1Alt: 'Voorbeeldafbeelding',

    ex2User: 'Gebruik Werydance2.0 om een dansvideo te maken.',
    ex2Bot1: 'Genereren met Werydance2.0 zoals gevraagd.',
    ex2Bot2: 'Klaar ✅ (model: Werydance2.0)',
    ex2LinkLabel: 'Video-URL:',
    ex2Bot3:
        'Ik kan ook een versie met meer “tech” podiumlicht of street dance proberen.',
    ex2Alt: 'Voorbeeldvideoframe',
    ex2Badge: 'GIF',

    ex3User: 'Genereer een Chinese podcast die WeryAI presenteert.',
    ex3Bot1:
        'Ik genereer een Chinese podcast met twee hosts over weryai.com.',
    ex3Bot2: 'Hier is de Chinese intro-podcast:',
    ex3AudioLabel: 'Podcast-audio (MP3)',
    ex3ParamsTitle: 'Parameters:',
    ex3ParamLang: 'Taal:',
    ex3ParamMode: 'Modus:',
    ex3ParamHosts: 'Hosts:',
    ex3ParamTaskId: 'Taak-ID:',
    ex3HostsValue: 'Xiaoman + Suzhe',
    ex3Bot4: 'Ik kan ook een kortere promo van 60–90 s maken.',
    ex3Filename: 'weryai_880c86f898ef76daea513e260046a21e.mp3',
    ex3Time: '0:07',

    linkPlaceholder: 'https://static.weryai.com/...',
    demoSlug: 'weryai-video-generator',
    demoInstallUrl:
        'https://clawhub.ai/WeryAI-Developer/weryai-video-generator',
}

const id = {
    skillsH1: 'Skills Resmi WeryAI',
    skillsPageTitle: 'Skills Resmi WeryAI',
    skillsIntro:
        'Skills resmi WeryAI membantu Anda mengintegrasikan WeryAI dengan cepat di platform asisten AI seperti OpenClaw dan menggunakan API pembuatan kami.',

    section1Title: 'Ringkasan Skills',
    clawHubMore: 'Lihat detail Skills di platform WeryAI',
    colSlug: 'Skill slug',
    colFeature: 'Fitur',
    colUrl: 'Tautan ClawHub',

    featVideoGen: 'Pembuatan video',
    featImageGen: 'Pembuatan gambar',
    featMusicGen: 'Pembuatan musik',
    featPodcastGen: 'Pembuatan podcast',
    featVideoEdit: 'Pengeditan video',
    featImageEdit: 'Pengeditan gambar',
    featAccount: 'Saldo API & kredit',

    section2Title: 'Cara memasang',
    method1Title: 'Metode 1',
    method1Hint: 'Katakan ke asisten 🦞:',
    method1LinePrefix: 'Pasang Skill:',

    method2Title: 'Metode 2',
    method2Hint: 'Katakan ke asisten 🦞:',
    method2Line1: 'Pasang Skill ini:',

    method3Title: 'Metode 3',
    method3Hint:
        'Buka ClawHub, cari weryai dan unduh file ZIP.',
    method3Box:
        'Ekstrak ZIP dan letakkan di folder skills OpenClaw lokal.',

    section3Title: 'Cara menggunakan',
    step1Title: 'Masuk ke weryai.com dan buat API Key',
    step1Warning: 'Simpan API Key Anda dengan aman dan jangan mudah membocorkannya.',
    step2Title:
        'Setelah menyelesaikan konfigurasi API di OpenClaw, kirim isi pesan.',
    step2CodePrefix: 'Isi pesan: lihat ilustrasi di bawah.',

    ex1User: 'Buat gambar seorang wanita dengan kopi.',
    ex1Bot1: 'Saya buatkan sekarang.',
    ex1Bot2: 'Selesai — berhasil dibuat ✅',
    ex1LinkLabel: 'URL gambar:',
    ex1Bot3:
        'Saya juga bisa menawarkan dua gaya lagi (realistis / sinematik).',
    ex1Alt: 'Gambar contoh',

    ex2User: 'Gunakan Werydance2.0 untuk membuat video tari.',
    ex2Bot1: 'Membuat dengan Werydance2.0 sesuai permintaan.',
    ex2Bot2: 'Selesai ✅ (model: Werydance2.0)',
    ex2LinkLabel: 'URL video:',
    ex2Bot3:
        'Saya juga bisa mencoba versi dengan panggung “tech” atau gaya street dance.',
    ex2Alt: 'Frame video contoh',
    ex2Badge: 'GIF',

    ex3User: 'Buat podcast bahasa Mandarin yang memperkenalkan WeryAI.',
    ex3Bot1:
        'Saya akan membuat podcast Mandarin dengan dua host tentang weryai.com.',
    ex3Bot2: 'Ini podcast pengantar bahasa Mandarin:',
    ex3AudioLabel: 'Audio podcast (MP3)',
    ex3ParamsTitle: 'Parameter:',
    ex3ParamLang: 'Bahasa:',
    ex3ParamMode: 'Mode:',
    ex3ParamHosts: 'Host:',
    ex3ParamTaskId: 'ID tugas:',
    ex3HostsValue: 'Xiaoman + Suzhe',
    ex3Bot4: 'Saya juga bisa membuat versi promo lebih pendek 60–90 dtk.',
    ex3Filename: 'weryai_880c86f898ef76daea513e260046a21e.mp3',
    ex3Time: '0:07',

    linkPlaceholder: 'https://static.weryai.com/...',
    demoSlug: 'weryai-video-generator',
    demoInstallUrl:
        'https://clawhub.ai/WeryAI-Developer/weryai-video-generator',
}

const tr = {
    skillsH1: 'WeryAI Resmi Skills',
    skillsPageTitle: 'WeryAI Resmi Skills',
    skillsIntro:
        "WeryAI'nin resmi Skills eklentileri, OpenClaw gibi AI asistan platformlarında WeryAI'yi hızlıca entegre etmenizi ve üretim API'lerimizi kullanmanızı sağlar.",

    section1Title: 'Skills genel bakış',
    clawHubMore: "WeryAI platformunda Skills detaylarını görüntüle",
    colSlug: 'Skill slug',
    colFeature: 'Özellik',
    colUrl: 'ClawHub bağlantısı',

    featVideoGen: 'Video üretimi',
    featImageGen: 'Görsel üretimi',
    featMusicGen: 'Müzik üretimi',
    featPodcastGen: 'Podcast üretimi',
    featVideoEdit: 'Video düzenleme',
    featImageEdit: 'Görsel düzenleme',
    featAccount: 'API bakiyesi ve krediler',

    section2Title: 'Nasıl kurulur',
    method1Title: 'Yöntem 1',
    method1Hint: 'Asistanınıza 🦞 söyleyin:',
    method1LinePrefix: 'Skill yükle:',

    method2Title: 'Yöntem 2',
    method2Hint: 'Asistanınıza 🦞 söyleyin:',
    method2Line1: 'Bu Skill’i yükle:',

    method3Title: 'Yöntem 3',
    method3Hint:
        'ClawHub’a gidin, weryai arayın ve ZIP dosyasını indirin.',
    method3Box:
        'ZIP’i açın ve yerel OpenClaw skills klasörüne yerleştirin.',

    section3Title: 'Nasıl kullanılır',
    step1Title: 'weryai.com’a giriş yapın ve API Key oluşturun',
    step1Warning: 'API Key’inizi güvenle saklayın ve kolayca ifşa etmeyin.',
    step2Title:
        'OpenClaw’da API yapılandırmasını tamamladıktan sonra mesaj içeriğini gönderin.',
    step2CodePrefix: 'Mesaj içeriği: aşağıdaki görsele bakın.',

    ex1User: 'Kadın ve kahve içeren bir görsel üret.',
    ex1Bot1: 'Hemen üretiyorum.',
    ex1Bot2: 'Tamam — başarıyla üretildi ✅',
    ex1LinkLabel: 'Görsel URL’si:',
    ex1Bot3:
        'Ayrıca iki stil daha (gerçekçi / sinematik) sunabilirim.',
    ex1Alt: 'Örnek görsel',

    ex2User: 'Dans videosu için Werydance2.0 kullan.',
    ex2Bot1: 'İstendiği gibi Werydance2.0 ile üretiyorum.',
    ex2Bot2: 'Tamam ✅ (model: Werydance2.0)',
    ex2LinkLabel: 'Video URL’si:',
    ex2Bot3:
        'Daha “tek” sahne ışığı veya street dance tarzı bir sürüm de deneyebilirim.',
    ex2Alt: 'Örnek video karesi',
    ex2Badge: 'GIF',

    ex3User: 'www.weryai.com’u tanıtan Çince bir podcast üret.',
    ex3Bot1:
        'weryai.com’u anlatan iki sunuculu Çince podcast üreteceğim.',
    ex3Bot2: 'İşte Çince giriş podcast’i:',
    ex3AudioLabel: 'Podcast sesi (MP3)',
    ex3ParamsTitle: 'Parametreler:',
    ex3ParamLang: 'Dil:',
    ex3ParamMode: 'Mod:',
    ex3ParamHosts: 'Sunucular:',
    ex3ParamTaskId: 'Görev ID:',
    ex3HostsValue: 'Xiaoman + Suzhe',
    ex3Bot4: 'Daha kısa 60–90 sn’lik bir promo kesim de yapabilirim.',
    ex3Filename: 'weryai_880c86f898ef76daea513e260046a21e.mp3',
    ex3Time: '0:07',

    linkPlaceholder: 'https://static.weryai.com/...',
    demoSlug: 'weryai-video-generator',
    demoInstallUrl:
        'https://clawhub.ai/WeryAI-Developer/weryai-video-generator',
}

export default {
    en,
    zh,
    tw,
    ja,
    ko,
    es,
    fr,
    de,
    ru,
    pt,
    it,
    ar,
    pl,
    th,
    da,
    no,
    nl,
    id,
    tr,
}
